var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sortable",on:{"click":function($event){$event.preventDefault();_vm.handleClick($event)}}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),(_vm.field === _vm.query.sort)?_c('span',[_vm._v("\n    "+_vm._s(_vm.order === 'asc' ? '↑' : '↓')+"\n  ")]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0710b535","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderTable/components/thSortable.vue
// module id = tcx/
// module chunks = 0